import { useEffect, useState } from 'react';
import { AudioTrack, AudioSelectType, settingControllerKey } from '../../PlayerModels';
import { VideoJsPlayer } from 'video.js';
import {
  CustomOption,
  CustomOptionWrapper,
  SettingPanelMultiSelectItem,
  SelectingItemMainWrapper,
} from '../../styles';
import { Box } from '../../../../styles';
import IconAudio from '../../../../icons/IconAudio';
import { PanelSettingHeader, PanelSettingLayer } from '../../styles/Panel';
import { findCaptionLabel } from '../../PlayerServices';

export default function ControlBarAudioPanel({ player, handleSettingItemClick, activeSetting }: {
  player: VideoJsPlayer,
  handleSettingItemClick: (controllerKey: settingControllerKey) => void
  activeSetting: string | null
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAudioTracks, setSelectedAudioTracks] = useState<{ language: string, label: string }>();
  const [audioTracks, setAudioTracks] = useState<AudioTrack[]>();

  useEffect(() => {
    const playerTracks = player.audioTracks().tracks_;
    player.audioTracks().addEventListener('change', handleUpdate);
    const trackList: AudioTrack[] = [];
    playerTracks.forEach((item: AudioTrack) => {
      item.enabled = item.language === player.cache_.selectedAudioTrack || item.language === 'fa' || item.enabled;
      trackList.push({
        id: item.id,
        kind: item.kind,
        label: findCaptionLabel(item.language),
        language: item.language,
        enabled: item.enabled,
      });
      if (item.enabled) {
        setSelectedAudioTracks({ label: findCaptionLabel(item.language), language: item.language });
      }
    });
    setAudioTracks(trackList);

    return () => {
      player.audioTracks().removeEventListener('change', handleUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  const handleUpdate = () => {
    const playerTracks = player.audioTracks().tracks_;
    const selected = playerTracks.find((t) => t.enabled);
    if (selected && (selected.language !== selectedAudioTracks?.language)) {
      setSelectedAudioTracks({
        language: selected.language,
        label: findCaptionLabel(selected.language),
      });
    }
  };

  const toggleMenu = (e, key) => {
    e.stopPropagation();
    handleSettingItemClick(key);
    setIsOpen(!isOpen);
  };

  const handleAudioTracksChange = (language: string) => {
    const audioTracks = player.audioTracks().tracks_;
    audioTracks.length && audioTracks.forEach((elem) => {
      elem.enabled = (elem.language === language);
    });
  };

  return (
    <>
      {!activeSetting &&
        <SettingPanelMultiSelectItem icon={<IconAudio />} label="player.audio" onClick={(e) => toggleMenu(e, 'audio')}
          value={selectedAudioTracks?.label as string} />}
      {activeSetting === 'audio' && <PanelSettingLayer>
        {audioTracks && selectedAudioTracks &&
          <AudioSelect options={audioTracks} returnAction={(e) => toggleMenu(e, null)} onChange={(language, label) => {
            if (language !== selectedAudioTracks?.language) {
              setSelectedAudioTracks({ language, label });
              handleAudioTracksChange(language);
              setIsOpen(false);
            }
          }} value={selectedAudioTracks.language} />}
      </PanelSettingLayer>}
    </>
  );
}
const AudioSelect = ({ value: selectValue, options, onChange, returnAction }: AudioSelectType) => {
  return (
    <Box>
      <PanelSettingHeader label={'player.audio'} handleClick={(e) => returnAction(e)} />
      <SelectingItemMainWrapper>
        {options.map((item: AudioTrack) => (
          <CustomOptionWrapper key={item.id} onClick={(e: any) => {
            onChange(item.language, item.label);
            returnAction(e);
          }}>
            <CustomOption selected={item.language === selectValue}>
              {item.label}
            </CustomOption>
          </CustomOptionWrapper>
        ))}
      </SelectingItemMainWrapper>
    </Box>
  );
};
